module.exports = __webpack_public_path__ + "static/media/cheat-sheet.0a549a2c.png";